import {
    RED,BLUE
} from '../action/TestAction'

let initialState = {
    color: "purple"
};

const TestReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case RED:
            return Object.assign({}, state, {
                color: "red"
            });
        case BLUE:
            return Object.assign({}, state, {
                color: "blue"
            });
        default:
            return state
    }
};

export default TestReducer;
